module.exports = __webpack_public_path__ + "img/07 Animation 2-squashed.b1aa066b.jpg";